export enum Roles {
  CenterAdmin = 'CenterAdmin',
  OrgAdmin = 'OrgAdmin',
  OfficeStaff = 'OfficeStaff',
  RoomStaff = 'RoomStaff',
  Client = 'Client',
  SuperAdmin = 'SuperAdmin',
  Anonymous = 'Anonymous',
}
